<template>
    <VueSlickCarousel
        v-if="shops && shops.length"
        v-bind="sliderOptions"
        class="smart-shops-slider"
    >
        <div v-for="item in shops" :key="item.id" class="maps__item">
            <h3 class="_adress" v-html="item.city"></h3>

            <h3 class="_adress" v-html="item.address"></h3>

            <div class="_text">
                <div class="_text__item">
                    Тел.:
                    <a
                        :href="`tel:${item.telephone}`"
                        class="smart-shops-slider__link"
                        >{{ item.telephone }}</a
                    >
                </div>

                <div class="_text__item">
                    Whatsapp :
                    <a
                        :href="`${item.whatsapp.link}`"
                        class="smart-shops-slider__link"
                        >{{ item.whatsapp.messanger_phone }}</a
                    >
                </div>

                <div class="_text__item">
                    Viber :
                    <a
                        :href="`${item.viber.link}`"
                        class="smart-shops-slider__link"
                        >{{ item.viber.messanger_phone }}</a
                    >
                </div>

                <div class="_text__item">
                    Telegram :
                    <a
                        :href="`${item.telegram.link}`"
                        class="smart-shops-slider__link"
                        >{{ item.telegram.messanger_phone }}</a
                    >
                </div>

                <div class="_text__item">
                    Почта :
                    <a
                        :href="`mailto:${item.email}`"
                        class="smart-shops-slider__link"
                    >
                        {{ item.email }}</a
                    >
                </div>
            </div>

            <div class="maps__choose">
                <img class="_img" :src="item.media.src" alt="item.media.alt" />
            </div>

            <button
                @click="selectHandler(item)"
                class="btn _primary _big _btn js-open-map go"
            >
                Выбрать
            </button>
        </div>

        <template #prevArrow>
            <button
                class="smart-shops-slider__slick-arrow smart-shops-slider__slick-arrow_prev"
            >
                <svg class="smart-shops-slider__icon-arrow">
                    <use xlink:href="#arrow-slider" />
                </svg>
            </button>
        </template>

        <template #nextArrow>
            <button class="smart-shops-slider__slick-arrow artest">
                <svg class="smart-shops-slider__icon-arrow">
                    <use xlink:href="#arrow-slider" />
                </svg>
            </button>
        </template>

        <template #customPaging="index">
            <!-- <div class="smart-shops-slider__dot" :index="index" /> -->
            <VueSlickCarouselDot />
        </template>
    </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import VueSlickCarouselDot from './UI/VueSlickCarouselDot.vue';

export default {
    components: {
        VueSlickCarousel,
        VueSlickCarouselDot,
    },

    props: {
        shops: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            sliderOptions: {
                infinite: false,
                dots: false,
                arrows: false,
                speed: 300,
                // centerMode: true,
                // centerPadding: '100px',
                // centerPadding: '20px',
                slidesToShow: 3,
                slidesToScroll: 1,
                // variableWidth: false,
                // slidesToShow: 1,
                // variableWidth: true,
                swipe: true,
                draggable: true,
                dots: true,
                arrows: true,

                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    // {
                    //     breakpoint: 992,
                    //     settings: {
                    //         variableWidth: false,
                    //         centerMode: false,
                    //         slidesToShow: 1,
                    //     },
                    // },
                ],
            },
        };
    },

    methods: {
        test(val) {
            console.log('test', val);
        },

        selectHandler(shop) {
            this.$emit('onSelect', shop);
        },

        /**
         * only for dev
         */
        // mediaSrcFix(src) {
        //     const q = 'http://localhost';
        //     const w = 'https://rolatex.ru';
        //     const newSrc = String(src).replace(q, w);

        //     return newSrc;
        // },
    },
};
</script>

<style lang="scss">
.smart-shops-slider {
    &__slick-arrow {
        position: absolute;
        z-index: 10;
        bottom: 0;
        // top: 50%;
        right: 0;

        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;

        border-radius: 50%;
        border: none;
        padding: 0;
        height: 50px;
        width: 50px;

        background-color: var(--c-primary);

        // transform: translateY(-50%);

        font-size: 0;
        line-height: 0;
        cursor: pointer;
    }

    &__slick-arrow_prev {
        left: 0;
        transform: rotateY(180deg);
    }

    &__icon-arrow {
        height: 50%;
        width: 50%;
    }

    .slick-list {
        margin-bottom: 1rem;
    }

    .slick-dots {
        display: flex !important;
        justify-content: center;
        flex-wrap: wrap;
        align-items: center;
        min-height: 50px;
        padding-left: 60px;
        padding-right: 60px;
    }

    &__link {
        color: var(--c-primary);
        text-decoration: underline;
        display: inline-block;
    }
}
</style>
